$(document).ready(function ()
{
  if ($('.o-js-investment_submit').length) {
    let input = $('.o-js-investment_form input[required="required"]').last()

    input.on('keyup', function(e) {
      if ($(this).val() == '') {
        $('.o-js-investment_submit').addClass('disabled').attr('disabled', true)
      } else {
        $('.o-js-investment_submit').removeClass('disabled').attr('disabled', false)
      }
    })
  }
})
